import React, { useState } from 'react';
import { Box, Typography, Grid, Paper, IconButton, InputBase } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { CustomButton } from '../../../shared';
import { CloseIcon, FilterLinesIcon } from '../../../../assets';
import { useDispatch } from 'react-redux';
import { fileUploadActions } from '../../../../redux/reducers/filesUploadReducer';

const SearchUsingFilter = (props) => {

    const { } = props;
    const dispatch = useDispatch();
    const handleSearch = (value) => {
        dispatch(fileUploadActions.handleSearch({searchTerm: value}))
    }

    return (
        <Box className="flex-row-space-between-center">
            {/* Search Box */}
            <Box>
                <Paper
                    component="form"
                    className='no-box-shadow'
                    sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: { md: 200, lg: 250, xl: 320, }, border: '1px solid #D0D5DD', borderRadius: '8px' }}
                >
                    <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                        <SearchIcon />
                    </IconButton>
                    <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        placeholder="Search"
                        inputProps={{ 'aria-label': 'search google maps' }}
                        onChange={(e)=>handleSearch(e.target.value)}
                    />
                </Paper>
            </Box>

        </Box>
    )
}

export default SearchUsingFilter